import { rem, SystemStyleObject } from '@vimeo/bokeh';

export const TOOL_TAB_ITEM_STYLE: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  flexBasis: 0,
  flexGrow: 1,
  maxWidth: '100%',
  maxHeight: '100%',
  overflowY: 'visible',
};

export function createTabWrapperStyle({ withScroll = false } = {}) {
  return {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%',
    padding: 0,
    ...(withScroll ? { overflowX: 'hidden', overflowY: 'auto' } : { overflow: 'hidden' }),
  };
}

/**
 * @param config - configuration object describing parameters of styles
 * @returns styling object for panel tabs list scrolls
 */
export function createTabListScrollStyle({
  fullWidth = false,
  position = 'relative',
}: { fullWidth?: boolean; position?: string } = {}): SystemStyleObject {
  return {
    position: position,
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: 0,
    ...(fullWidth ? { width: '100%' } : { marginRight: rem(-16) }),
  };
}

export function createTabListColumnStyle(withScrollMargin: boolean = true) {
  return {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    alignContent: 'flex-start',
    gap: `${rem(8)} ${rem(8)}`,
    ...(withScrollMargin
      ? {
          '& > :last-child': {
            marginBottom: rem(16),
          },
        }
      : {}),
  };
}

// todo: Constant.
export function createTabListColumnHalfItemStyle({ withBorder = true } = {}): SystemStyleObject {
  return {
    overflow: 'hidden',
    width: rem(140),
    height: rem(79),
    boxSizing: 'border-box',
    position: 'relative',
    transitionDuration: '0.5s',
    borderRadius: rem(8),
    border: '1px solid',
    borderColor: withBorder ? 'stroke' : 'transparent',
  };
}

export const TAB_LIST_COLUMN_FULL_ITEM_STYLE: SystemStyleObject = {
  width: rem(288),
  position: 'relative',
};

export const TAB_LIST_COLUMN_ROW_ITEM_STYLE: SystemStyleObject = {
  width: '100%',
  position: 'relative',
};

export const TABS_STYLES: SystemStyleObject = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const TAB_PANELS_STYLES: SystemStyleObject = {
  display: 'flex',
  flexGrow: 1,
};

export const TAB_PANEL_STYLES: SystemStyleObject = {
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  rowGap: rem(16),
  marginTop: rem(16),
  width: '100%',
};
